import { Col, Row, Button } from 'antd';
import { OnboardMessage } from '@copilot/data/requests/models';
import DeleteButton from '@copilot/common/components/button/delete';
import Title from '@copilot/common/typography/title';
import {
    CAMPAIGN_MESSAGE_EDIT_TRACKING_ID,
    CAMPAIGN_MESSAGE_DELETE_TRACKING_ID,
} from '@copilot/common/tracking/userpilotEventConsts';

/**
 * Diplay message with option of edit and delete
 *
 * @param messageTitle message title
 * @param message message
 * @callback onEditClick called on edit
 * @param isEditing edit status of a message - true when editing a message, false when viewing a message
 * @param isEditable whether a message is editable
 * @param isDeletable whether a message is deletable
 * @callback handleDelete called on delete
 */
interface MessageHeaderProps {
    messageTitle: string;
    message: OnboardMessage;
    onEditClick: () => void;
    isEditable: boolean;
    isDeletable?: boolean;
    onDeleteClick: (message: OnboardMessage) => void;
}

function MessageHeader({
    messageTitle,
    message,
    onEditClick,
    isDeletable = false,
    onDeleteClick,
    isEditable,
}: MessageHeaderProps) {
    return (
        <Row gutter={16}>
            <Col>
                <Title level={5}>{messageTitle}</Title>
            </Col>
            <Col>
                <Button
                    onClick={onEditClick}
                    disabled={!isEditable}
                    size="small"
                    data-tracking-id={CAMPAIGN_MESSAGE_EDIT_TRACKING_ID}
                >
                    Edit
                </Button>
            </Col>
            <Col>
                {isDeletable && (
                    <DeleteButton
                        label="Delete"
                        confirmText="Are you sure you want to delete this message?"
                        deleteAction={() => onDeleteClick(message)}
                        size="small"
                        disabled={!isEditable}
                        data-tracking-id={CAMPAIGN_MESSAGE_DELETE_TRACKING_ID}
                    />
                )}
            </Col>
        </Row>
    );
}

export default MessageHeader;
